export default __webpack_public_path__ + "static/media/DisbursementPending.4229e010.png";